<template>
    <section class="container landing-footer">
        <div class="rights-reserved">
          <!--<div class="btns-box">-->
            <!--<b-link v-for="item of btns"-->
                    <!--:key="item.name"-->
                    <!--:href="item.url"-->
                    <!--target="_blank"-->
                    <!--v-m-ua-event="['footer', 'link', item.name]"-->
                    <!--class="btns">{{item.name}}</b-link>-->
          <!--</div>-->
          <p style="color: #aaa;">Copyright &copy; {{year}} {{ siteName}} All rights reserved.</p>
        </div>
        <div class="right-box company-info">
          <p class="powered-by">Powered By</p>
          <b-link :href="this.$store.state.config.link.home"
                  target="_blank"
                  class="powered-by"
                  v-m-ua-event="['footer', 'logo', 'usa data']">
            <img src="../../assets/images/usadata-logo.png" />
          </b-link>
          <p class="powered-by">875 3rd Ave, 6th floor, New York, NY 10022</p>
          <p class="powered-by">800.395.7707 | info@usadata.com</p>
        </div>
    </section>
  </b-container>
</template>

<script>
  export default {
    data () {
      return {
        btns: [
          {
            name: 'About Us',
            url: this.$store.state.config.link.aboutUs
          },
          {
            name: 'Privacy Policy',
            url: this.$store.state.config.link.privacy
          },
          {
            name: 'Twitter',
            url: this.$store.state.config.link.twitter
          }
        ]
      }
    },
    computed: {
      year () {
        let today = new Date()
        return today.getFullYear()
      },
      siteName()  {
         return `${this.$store.state.site.SiteName}, Inc.`
      }
    }
  }
</script>
<style scoped lang="scss">
  .footer{
      display: flex;
      min-height: 160px;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 16px;
      margin-top: 32px;
    }

  .powered-by {
    color: #aaa;
    text-align: right;
    margin-bottom: 0;
  }

  .btns {
    margin-right: 16px;
  }
  .right-box {
    text-align: right;
  }
  .btns-box {
    text-align: left;
  }

  @media(max-width: 768px) {
    .footer{
      flex-direction: column;
      align-items: flex-start;
      padding-left: 0;
    }
    .right-box {
      margin-bottom: 16px;
      text-align: left;
    }
    .powered-by {
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/MFooter.vue